import React, { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useHistory } from "react-router-dom"
import './main.css'
import register from "assets/images/svg/main_register.svg";
import login from "assets/images/svg/main_login.svg";
import logout from "assets/images/svg/main_logout.svg";
import logo from "assets/images/new_main_logo.png";
import menubarImage from "assets/images/menubar_image.png";
import menubarLogo from "assets/images/menubar_logo.png";
import menubarArrow from "assets/images/svg/menubar_arrow.svg";
import kakaotalk from "assets/images/kakaotalk.png";
import naverblog from "assets/images/naverblog.png";
import youtube from "assets/images/youtube.png";
import facebook from "assets/images/facebook.png";
import instagram from "assets/images/instagram.png";
import hamburgerMenu from "assets/images/svg/hamburger_menu.svg";
import BusinessIntroduction from "./BusinessIntroduction";
import ServiceIntroduction from "./ServiceIntroduction";
import StoreEntryInformation from "./StoreEntryInformation";
import CustomerSupport from "./CustomerSupport";
import appstore from "assets/images/appstore.png";
import playstore from "assets/images/playstore.png";
import download from "assets/images/svg/download_white.svg";

import { CLEAR_AUTH } from "store/auth/profile/actionTypes"
import { LOGOUT_USER } from "store/auth/login/actionTypes"
import { CLEAR_DATA } from "store/auth/data/actionTypes"
import store from "../../store"
import SweetAlert from "react-bootstrap-sweetalert";
import $ from 'jquery';

const Main = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const menu = queryParams.get('menu') || 'business-introduction'
  const history = useHistory()

  const [isLogin, setIsLogin] = useState(false);
  const [menubarShow, setMenubarShow] = useState(false);
  const [mobileMenubarShow, setMobileMenubarShow] = useState(false);
  const [modalShow, setModalShow] = useState({
    service: false
  });
  const [alertTitle, setAlertTitle] = useState({
    service: ''
  });

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const writeAlertTitle = (key, title) => {
    setAlertTitle(prev => ({ ...prev, [key]: title }))
  }

  const smsItems = [
    { img: kakaotalk, link: 'http://pf.kakao.com/_xffgin' },
    { img: naverblog, link: 'https://blog.naver.com/wasteverse' },
    { img: youtube },
    { img: facebook },
    { img: instagram },
  ]

  const navItems = [
    { title: "사업소개", param: "business-introduction", component: <BusinessIntroduction /> },
    { title: "서비스 소개", param: "service-introduction", component: <ServiceIntroduction /> },
    { title: "입점 안내", param: "store-entry-information", component: <StoreEntryInformation /> },
    { title: "고객지원", param: "customer-support", component: <CustomerSupport /> },
  ];

  const handleClick = (page) => {
    const url = {
      pathname: `/${page}`
    }
    history.push(url);
  }

  const handleLogout = async () => {
    localStorage.removeItem('ACCESS_TOKEN')
    localStorage.removeItem('authUser');
    store.dispatch({ type: CLEAR_AUTH })
    store.dispatch({ type: LOGOUT_USER })
    store.dispatch({ type: CLEAR_DATA })
    await persistor.purge()
  }

  const userActions = [
    {
      title: isLogin ? "관리자" : "관리자/로그인",
      icon: login,
      alt: "Login neaticons",
      action: () => handleClick(isLogin ? "dashboard" : "login"),
      isShow: true
    },
    {
      title: "로그아웃",
      icon: logout,
      alt: "Logout neaticons",
      action: handleLogout,
      isShow: isLogin
    },
    {
      title: "회원가입",
      icon: register,
      alt: "User neaticons",
      action: () => handleClick("select-type"),
      isShow: !isLogin
    },
  ];

  const companyInfo = {
    section1: {
      title: "WASTEVERSE CO., LTD",
      details: "사업자등록번호: 765-86-02996\n통신판매업신고번호: 제2019-서울금천-2212 호\n대표이사 : 김호중"
    },
    section2: {
      title: "주식회사 웨이스트버스",
      details: "서울특별시 금천구 가산디지털2로 67 에이스하이엔드타워7 9층 902호\nTel : 02-567-6601 | Fax : 02-567-6603\nE-mail : info@wasteverse.co.kr"
    },
  };

  const footerLinks = ["개인정보처리방침 | ", "개인정보책임자 : 이병교 | 02-567-6601 | admin@wasteverse.co.kr"];

  const menubarList = [
    {
      title: '사업소개',
      click: 'sec_1_1',
      param: 'business-introduction',
      menu: [
        { title: '사업소개', click: 'sec_1_2', param: 'business-introduction' },
        { title: '핵심가치', click: 'sec_1_3', param: 'business-introduction' },
        { title: '핵심기술', click: 'sec_1_4', param: 'business-introduction' },
        { title: '사회적 가치', click: 'sec_1_5', param: 'business-introduction' },
        { title: '입점안내', click: 'sec_1_6', param: 'business-introduction' },
        { title: '고객지원', click: 'sec_1_6', param: 'business-introduction' },
      ]
    },
    {
      title: '서비스 소개',
      click: 'sec_2_1',
      param: 'service-introduction',
      menu: [
        { title: '플랫폼 서비스', click: 'sec_2_2', param: 'service-introduction' },
        { title: '플랫폼 서비스 흐름도', click: 'sec_2_3', param: 'service-introduction' },
        { title: '차별성', click: 'sec_2_4', param: 'service-introduction' },
        { title: '주요기능', click: 'sec_2_5', param: 'service-introduction' },
        { title: '디바이스 소개', click: 'sec_2_6', param: 'service-introduction' },
        { title: '데이터 흐름도', click: 'sec_2_7', param: 'service-introduction' },
        { title: '경쟁사 비교 및 차별성', click: 'sec_2_8', param: 'service-introduction' },
        { title: '입점안내', click: 'sec_3_2', param: 'store-entry-information' },
        { title: '고객지원', click: 'sec_4_4', param: 'customer-support' },
      ]
    },
    {
      title: '입점 안내',
      click: 'sec_3_1',
      param: 'store-entry-information',
      menu: [
        { title: '입점절차', click: 'sec_3_2', param: 'store-entry-information' },
        { title: '문의하기', click: 'sec_3_3', param: 'store-entry-information' },
        { title: 'FAQ', click: 'sec_3_4', param: 'store-entry-information' },
        { title: '파트너사', click: 'sec_3_5', param: 'store-entry-information' },
      ]
    },
    {
      title: '고객지원',
      click: 'sec_4_1',
      param: 'customer-support',
      menu: [
        { title: '새소식/언론보도', click: 'sec_4_5', param: 'customer-support' },
        { title: '회사소개서', click: 'sec_4_3', param: 'customer-support' },
        { title: '문의하기', click: 'sec_4_4', param: 'customer-support' },
      ]
    },
  ]

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "auto";
    if (location.state?.top) {
      var offset = $('#' + location.state?.top).offset().top - 108;
      $('html, body').scrollTop(offset);
    } else {
      $('html, body').scrollTop(0);
    }
    document.documentElement.style.scrollBehavior = "";
  }, [menu])

  useEffect(() => {
    const loginData = localStorage.getItem('authUser');
    if (loginData) {
      setIsLogin(true)
    }
  }, [isLogin])

  const handleMouseEnter = () => {
    //console.log('들어옴')
    setMenubarShow(true)
  }

  const handleMouseLeave = () => {
    //console.log('나감')
    setMenubarShow(false)
  }

  const goTargetMenu = (e, target, param) => {
    e.preventDefault();
    if (menu != param) {
      document.documentElement.style.scrollBehavior = "auto";
      $('html, body').scrollTop(0);
      document.documentElement.style.scrollBehavior = "";
      history.push(`/main?menu=${param}`, { top: target })
    } else {
      var offset = $('#' + target).offset().top - 108;

      $('html, body').animate({
        scrollTop: offset
      }, 100);
    }
    setMenubarShow(false)
    setMobileMenubarShow(false)
  }

  return (
    <div className="main" style={{ width: '100%', backgroundColor: "white", position: 'relative' }}>
      <header
        className="header"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="header-nav-bar">
          <img src={logo} style={{ width: 251, height: 30, cursor: "pointer" }} onClick={() => {
            history.push('/main')
            setMenubarShow(false)
            setMobileMenubarShow(false)
          }} />
          <div className="nav-menu">
            {navItems.map((item, index) => (
              <p key={'nav_item_' + index} style={{ width: 150, marginBottom: 0, color: '#1F2D3D', fontWeight: 'bold', fontSize: 18, cursor: 'pointer' }} onClick={() => {
                document.documentElement.style.scrollBehavior = "auto";
                $('html, body').scrollTop(0);
                document.documentElement.style.scrollBehavior = "";
                history.push(`/main?menu=${item.param}`)
                setMenubarShow(false)
                setMobileMenubarShow(false)
              }}>{item.title}</p>
            ))}
          </div>
          <div className="user-menu">
            {userActions
              .filter(item => item.isShow)
              .map((item, index) => (
                <button key={'user_action_' + index} style={{ border: '1px solid #1F2D3D', padding: '6px 14px', borderRadius: 90, backgroundColor: 'white', display: 'flex', gap: 4, alignItems: "center" }} onClick={item.action} >
                  <img style={{ width: 16, height: 16, color: '#1F2D3D' }} src={item.icon} alt={item.alt} />
                  <span style={{ fontSize: 13, color: '#1F2D3D', fontWeight: '500' }}> {item.title} </span>
                </button>
              ))}
          </div>
          <img className="hamburger-menu" src={hamburgerMenu} onClick={() => {
            setMobileMenubarShow(prev => !prev)
          }} />
        </div>
        {/* {mobileMenubarShow && */}
          <div className={`mobile-menubar-container ${mobileMenubarShow ? "show" : ""}`}>
            <div style={{width: '100%', padding: 28, display: "flex", justifyContent: "end"}}>
              <button style={{ border: '1px solid #1F2D3D', padding: '6px 14px', borderRadius: 90, display: 'flex', gap: 4, alignItems: "center" }} onClick={() => {handleClick("select-type")}} >
                <img style={{ width: 16, height: 16, color: '#1F2D3D' }} src={register} alt={'User neaticons'} />
                <span style={{ fontSize: 13, color: '#1F2D3D', fontWeight: '500' }}>회원가입</span>
              </button>
            </div>
            <div style={{padding: '0 18px 18px 18px', display: "flex", flexWrap: "wrap", gap: '28px 20px'}}>
              {menubarList.map((item, index) => (
                <div key={'menubar_item_' + index} style={{ width: 152 }}>
                  <div style={{ width: '100%', height: 37, borderBottom: '1px solid #D9DDE4', padding: '8px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onClick={(e) => {
                    goTargetMenu(e, item.click, item.param)
                  }}>
                    <p>{item.title}</p>
                    <img src={menubarArrow} />
                  </div>
                  {index !== 1 ?
                    <div style={{ width: '100%', marginTop: 14, display: 'flex', flexDirection: "column", gap: 8 }}>
                      {item.menu.map((subItem, subIndex) => (
                        <p key={'menubar_subitem_' + subIndex} style={{ fontWeight: '500', fontSize: 15, lineHeight: '140%', color: '#707E92', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, subItem.click, subItem.param) }}>
                          ㆍ{subItem.title}
                        </p>
                      ))}
                    </div>
                    :
                    <div>
                      <div style={{ width: '100%', marginTop: 14, display: 'flex', flexDirection: "column", gap: 8 }}>
                        <p style={{ paddingLeft: 12, color: '#3C4858', fontWeight: '500', fontSize: 15, lineHeight: '140%', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, 'sec_2_1', 'service-introduction') }}>플랫폼(PLATFORM)</p>
                        {item.menu.slice(0, 4).map((subItem, subIndex) => (
                          <p key={'menubar_subitem_' + subIndex} style={{ fontWeight: '500', fontSize: 15, lineHeight: '140%', color: '#707E92', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, subItem.click, subItem.param) }}>
                            ㆍ{subItem.title}
                          </p>
                        ))}
                      </div>
                      <div style={{ width: '100%', marginTop: 20, display: 'flex', flexDirection: "column", gap: 8 }}>
                        <p style={{ paddingLeft: 12, color: '#3C4858', fontWeight: '500', fontSize: 15, lineHeight: '140%', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, 'sec_2_9', 'service-introduction') }}>디바이스(DEVICE)</p>
                        {item.menu.slice(4).map((subItem, subIndex) => (
                          <p key={'menubar_subitem_' + subIndex} style={{ fontWeight: '500', fontSize: 15, lineHeight: '140%', color: '#707E92', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, subItem.click, subItem.param) }}>
                            ㆍ{subItem.title}
                          </p>
                        ))}
                      </div>
                    </div>
                  }
                </div>
              ))}
            </div>
          </div>
        {/* } */}
        {/* {menubarShow && */}
          <div className={`menubar-container ${menubarShow ? "show" : ""}`}>
            <div style={{ width: 650, height: '100%', backgroundColor: 'rgba(239, 241, 242, 0.9)' }}>
              <div style={{ marginLeft: 208, marginTop: 90, width: 380 }}>
                <p style={{ color: '#1F2D3D', fontWeight: '700', fontSize: 28, lineHeight: '140%' }}>“웨이스트버스"</p>
                <p style={{ marginTop: 10, color: '#808080', fontWeight: '500', fontSize: 16, lineHeight: '150%' }}>IOT 기술 기반 음식물 폐기물<br />스마트 수거의 혁신 플랫폼</p>
                <img src={menubarImage} style={{ marginTop: 30, width: '100%', height: 140, objectFit: 'cover', objectPosition: 'center' }} />
              </div>
            </div>
            <div style={{ flexGrow: 1, height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
              <div style={{ marginTop: 41, marginLeft: 56, display: 'flex', gap: 40 }}>
                {menubarList.map((item, index) => (
                  <div key={'menubar_item_' + index} style={{ width: 160 }}>
                    <div style={{ width: '100%', height: 37, borderBottom: '1px solid #D9DDE4', padding: '8px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <p>{item.title}</p>
                      <img src={menubarArrow} />
                    </div>
                    {index !== 1 ?
                      <div style={{ width: '100%', marginTop: 14, display: 'flex', flexDirection: "column", gap: 8 }}>
                        {item.menu.map((subItem, subIndex) => (
                          <p key={'menubar_subitem_' + subIndex} style={{ fontWeight: '500', fontSize: 15, lineHeight: '140%', color: '#707E92', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, subItem.click, subItem.param) }}>
                            ㆍ{subItem.title}
                          </p>
                        ))}
                      </div>
                      :
                      <div>
                        <div style={{ width: '100%', marginTop: 14, display: 'flex', flexDirection: "column", gap: 8 }}>
                          <p style={{ paddingLeft: 12, color: '#3C4858', fontWeight: '500', fontSize: 15, lineHeight: '140%', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, 'sec_2_1', 'service-introduction') }}>플랫폼(PLATFORM)</p>
                          {item.menu.slice(0, 4).map((subItem, subIndex) => (
                            <p key={'menubar_subitem_' + subIndex} style={{ fontWeight: '500', fontSize: 15, lineHeight: '140%', color: '#707E92', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, subItem.click, subItem.param) }}>
                              ㆍ{subItem.title}
                            </p>
                          ))}
                        </div>
                        <div style={{ width: '100%', marginTop: 20, display: 'flex', flexDirection: "column", gap: 8 }}>
                          <p style={{ paddingLeft: 12, color: '#3C4858', fontWeight: '500', fontSize: 15, lineHeight: '140%', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, 'sec_2_9', 'service-introduction') }}>디바이스(DEVICE)</p>
                          {item.menu.slice(4).map((subItem, subIndex) => (
                            <p key={'menubar_subitem_' + subIndex} style={{ fontWeight: '500', fontSize: 15, lineHeight: '140%', color: '#707E92', cursor: 'pointer' }} onClick={(e) => { goTargetMenu(e, subItem.click, subItem.param) }}>
                              ㆍ{subItem.title}
                            </p>
                          ))}
                        </div>
                      </div>
                    }
                  </div>
                ))}
              </div>
            </div>
            <img src={menubarLogo} style={{ position: 'absolute', right: 0, bottom: 0 }} />
          </div>
        {/* } */}
      </header>

      {navItems.map((item, index) => (
        menu === item.param && <Fragment key={item.param + index}>{item.component}</Fragment>
      ))}

      <footer style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div style={{ width: '100%', backgroundColor: '#222222', padding: '10px 0' }}>
          <div className="footer-container inner-container">
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '30px 0', justifyContent: "center"}}>
              <div className="footer-content-container">
                <p style={{ fontWeight: 600, fontSize: 18, lineHeight: '140%', color: '#999999' }}>{companyInfo.section1.title}</p>
                <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 5 }}>
                  {companyInfo.section1.details.split('\n').map((line, i) => (
                    <p key={line + i} style={{ fontSize: 14, lineHeight: '140%', color: '#999999' }}>{line}</p>
                  ))}
                </div>
              </div>
              <div className="footer-content-container">
                <p style={{ fontWeight: 600, fontSize: 18, lineHeight: '140%', color: '#999999' }}>{companyInfo.section2.title}</p>
                <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 5 }}>
                  {companyInfo.section2.details.split('\n').map((line, i) => (
                    <p key={line + i} style={{ fontSize: 14, lineHeight: '140%', color: '#999999' }}>{line}</p>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <div style={{ display: "flex", gap: 16 }}>
                {smsItems.map((item, index) => (
                  <img style={{ cursor: 'pointer', width: 40, height: 40 }} key={'sms_icons_' + index} src={item.img} onClick={() => {
                    if (item.link) {
                      window.open(item.link, '_blank')
                    } else {
                      modalOpen('service')
                      writeAlertTitle('service', '서비스 준비중입니다.')
                    }
                  }} />
                ))}
              </div>
              <div style={{marginTop: 32}}>
                <p style={{color: "#999", fontSize: 12}}>[웨이스트버스 앱 다운받기]</p>
                <div style={{display: "flex", justifyContent: "space-between", marginTop: 8}}>
                  <button style={{width: 124, height: 28, backgroundColor: 'black', borderRadius: 4, boxShadow: "none", borderWidth: 0, display: "flex", alignItems: "center", gap: 8, padding: '0 8px'}} onClick={() => {
                    modalOpen('service')
                    writeAlertTitle('service', '서비스 준비중입니다.')
                  }}>
                    <img src={playstore} style={{width: 14}} />
                    <p style={{fontSize: 10, color: "white", flexGrow: 1, textAlign: "left", lineHeight: '100%'}}>Google Play</p>
                    <img src={download} style={{width: 14}} />
                  </button>
                  <button style={{width: 124, height: 28, backgroundColor: 'black', borderRadius: 4, boxShadow: "none", borderWidth: 0, display: "flex", alignItems: "center", gap: 8, padding: '0 8px'}} onClick={() => {
                    modalOpen('service')
                    writeAlertTitle('service', '서비스 준비중입니다.')
                  }}>
                    <img src={appstore} style={{width: 14}} />
                    <p style={{fontSize: 10, color: "white", flexGrow: 1, textAlign: "left", lineHeight: '100%'}}>App Store</p>
                    <img src={download} style={{width: 14}} />
                  </button>
                </div>
              </div>
            </div>
            {/* <div style={{ display: 'flex', width: '100%', maxWidth: '1200px', alignItems: 'flex-start', justifyContent: 'center', gap: '60px', paddingTop: '30px', paddingBottom: '30px' }}>
            <div style={{ display: 'flex' }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '360px', alignItems: 'flex-start', justifyContent: 'center', gap: '1.25rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '0.625rem' }}>
                  <h3 style={{ fontFamily: 'Pretendard-SemiBold, Helvetica, sans-serif', fontWeight: 600, color: '#999999', fontSize: '1.125rem', lineHeight: '25.2px' }}>
                    {companyInfo.section1.title}
                  </h3>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '5px' }}>
                  {companyInfo.section1.details.map((detail, index) => (
                    <p
                      key={`company-detail-1-${index}`}
                      style={{ fontFamily: 'Pretendard-Regular, Helvetica, sans-serif', fontWeight: 'normal', color: '#999999', fontSize: '0.875rem', lineHeight: '19.6px' }}
                    >
                      {detail}
                    </p>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column',alignItems: 'flex-start', justifyContent: 'center', gap: '1.25rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '0.625rem' }}>
                  <h3 style={{ fontFamily: 'Pretendard-SemiBold, Helvetica, sans-serif', fontWeight: 600, color: '#999999', fontSize: '1.125rem', lineHeight: '25.2px' }}>
                    {companyInfo.section2.title}
                  </h3>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '5px' }}>
                  {companyInfo.section2.details.map((detail, index) => {
                    if (typeof detail === "string") {
                      return (
                        <p
                          key={`company-detail-2-${index}`}
                          style={{ fontFamily: 'Pretendard-Regular, Helvetica, sans-serif', fontWeight: 'normal', color: '#999999', fontSize: '0.875rem', lineHeight: '19.6px' }}
                        >
                          {detail}
                        </p>
                      );
                    } else if (detail.type === "inline") {
                      return (
                        <div
                          key={`company-detail-2-${index}`}
                          style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}
                        >
                          {detail.content.map((item, idx) => (
                            <React.Fragment key={`inline-item-${idx}`}>
                              <span style={{ fontFamily: 'Pretendard-Regular, Helvetica, sans-serif', fontWeight: 'normal', color: '#999999', fontSize: '0.875rem', lineHeight: '19.6px' }}>
                                {item}
                              </span>
                              {idx < detail.content.length - 1 && (
                                <span style={{ fontFamily: 'Pretendard-Regular, Helvetica, sans-serif', fontWeight: 'normal', color: '#5e5c5c', fontSize: '0.75rem', letterSpacing: '-0.50px', lineHeight: '16.8px' }}>
                                |
                                </span>
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            </div>

            <div style={{display: "flex", gap: 16}}>
              {smsItems.map((item, index) => (
              <img style={{cursor: 'pointer'}} key={'sms_icons_'+index} src={item.img} onClick={() => {
                modalOpen('service')
                writeAlertTitle('service', '서비스 준비중입니다.')
              }} />
              ))}
            </div>
          </div> */}
          </div>
        </div>

        <div className="rights-container">
          <div className="rights-container-inner">
            <div style={{ display: 'flex', flexDirection: 'column', width: '360px', alignItems: 'flex-start', justifyContent: 'center', gap: '1.25rem' }}>
              <p style={{ fontFamily: 'Pretendard-Medium, Helvetica, sans-serif', fontWeight: 500, color: '#999999', fontSize: '0.875rem', lineHeight: '19.6px' }}>
                ⓒ 2024 WASTEVERSE, ALL Rights Reserved
              </p>
            </div>

            <div className="footer-links-container">
              <p>
                {footerLinks.map((link, index) => (
                  <span style={{ fontFamily: 'Pretendard-Regular, Helvetica, sans-serif', fontWeight: 'normal', color: '#999999', fontSize: '0.875rem', lineHeight: '19.6px', cursor: 'pointer' }}>
                    {link}
                  </span>
                ))}
              </p>
            </div>
          </div>
        </div>
      </footer>
      {modalShow.service &&
        <SweetAlert
          title={<span className='justify-content-center d-flex noMargin text-black font-weight-bold font-size-18' style={{ marginBottom: 10, marginTop: 10 }}>
            {alertTitle.service}
          </span>}
          onConfirm={() => {
            modalClose('service')
          }}
        />
      }
    </div>
  )
};

export default Main